/*                                                                           */

import { DEV } from 'esm-env';

var bold = 'font-weight: bold';
var normal = 'font-weight: normal';

/**
 *
 *
 *
 */
export function assignment_value_stale(property, location) {
	if (DEV) {
		console.warn(`%c[svelte] assignment_value_stale\n%cAssignment to \`${property}\` property (${location}) will evaluate to the right-hand side, not the value of \`${property}\` following the assignment. This may result in unexpected behaviour.\nhttps:/*                                                  */
	} else {
		console.warn(`https:/*                                    */
	}
}

/**
 *
 *
 */
export function await_reactivity_loss(name) {
	if (DEV) {
		console.warn(`%c[svelte] await_reactivity_loss\n%cDetected reactivity loss when reading \`${name}\`. This happens when state is read in an async function after an earlier \`await\`\nhttps:/*                                                 */
	} else {
		console.warn(`https:/*                                   */
	}
}

/**
 *
 *
 *
 */
export function await_waterfall(name, location) {
	if (DEV) {
		console.warn(`%c[svelte] await_waterfall\n%cAn async derived, \`${name}\` (${location}) was not read immediately after it resolved. This often indicates an unnecessary waterfall, which can slow down your app\nhttps:/*                                           */
	} else {
		console.warn(`https:/*                             */
	}
}

/**
 *
 *
 *
 */
export function binding_property_non_reactive(binding, location) {
	if (DEV) {
		console.warn(
			`%c[svelte] binding_property_non_reactive\n%c${location
				? `\`${binding}\` (${location}) is binding to a non-reactive property`
				: `\`${binding}\` is binding to a non-reactive property`}\nhttps:/*                                          */
			bold,
			normal
		);
	} else {
		console.warn(`https:/*                                           */
	}
}

/**
 *
 *
 */
export function console_log_state(method) {
	if (DEV) {
		console.warn(`%c[svelte] console_log_state\n%cYour \`console.${method}\` contained \`$state\` proxies. Consider using \`$inspect(...)\` or \`$state.snapshot(...)\` instead\nhttps:/*                                             */
	} else {
		console.warn(`https:/*                               */
	}
}

/**
 *
 *
 *
 */
export function event_handler_invalid(handler, suggestion) {
	if (DEV) {
		console.warn(`%c[svelte] event_handler_invalid\n%c${handler} should be a function. Did you mean to ${suggestion}?\nhttps:/*                                                 */
	} else {
		console.warn(`https:/*                                   */
	}
}

/**
 *
 *
 */
export function hydratable_missing_but_expected(key) {
	if (DEV) {
		console.warn(`%c[svelte] hydratable_missing_but_expected\n%cExpected to find a hydratable with key \`${key}\` during hydration, but did not.\nhttps:/*                                                           */
	} else {
		console.warn(`https:/*                                             */
	}
}

/**
 *
 *
 *
 *
 */
export function hydration_attribute_changed(attribute, html, value) {
	if (DEV) {
		console.warn(`%c[svelte] hydration_attribute_changed\n%cThe \`${attribute}\` attribute on \`${html}\` changed its value between server and client renders. The client value, \`${value}\`, will be ignored in favour of the server value\nhttps:/*                                                       */
	} else {
		console.warn(`https:/*                                         */
	}
}

/**
 *
 *
 */
export function hydration_html_changed(location) {
	if (DEV) {
		console.warn(
			`%c[svelte] hydration_html_changed\n%c${location
				? `The value of an \`{@html ...}\` block ${location} changed between server and client renders. The client value will be ignored in favour of the server value`
				: 'The value of an `{@html ...}` block changed between server and client renders. The client value will be ignored in favour of the server value'}\nhttps:/*                                   */
			bold,
			normal
		);
	} else {
		console.warn(`https:/*                                    */
	}
}

/**
 *
 *
 */
export function hydration_mismatch(location) {
	if (DEV) {
		console.warn(
			`%c[svelte] hydration_mismatch\n%c${location
				? `Hydration failed because the initial UI does not match what was rendered on the server. The error occurred near ${location}`
				: 'Hydration failed because the initial UI does not match what was rendered on the server'}\nhttps:/*                               */
			bold,
			normal
		);
	} else {
		console.warn(`https:/*                                */
	}
}

/**
 *
 */
export function invalid_raw_snippet_render() {
	if (DEV) {
		console.warn(`%c[svelte] invalid_raw_snippet_render\n%cThe \`render\` function passed to \`createRawSnippet\` should return HTML for a single element\nhttps:/*                                                      */
	} else {
		console.warn(`https:/*                                        */
	}
}

/**
 *
 *
 */
export function legacy_recursive_reactive_block(filename) {
	if (DEV) {
		console.warn(`%c[svelte] legacy_recursive_reactive_block\n%cDetected a migrated \`$:\` reactive block in \`${filename}\` that both accesses and updates the same reactive value. This may cause recursive updates when converted to an \`$effect\`.\nhttps:/*                                                           */
	} else {
		console.warn(`https:/*                                             */
	}
}

/**
 *
 */
export function lifecycle_double_unmount() {
	if (DEV) {
		console.warn(`%c[svelte] lifecycle_double_unmount\n%cTried to unmount a component that was not mounted\nhttps:/*                                                    */
	} else {
		console.warn(`https:/*                                      */
	}
}

/**
 *
 *
 *
 *
 *
 */
export function ownership_invalid_binding(parent, prop, child, owner) {
	if (DEV) {
		console.warn(`%c[svelte] ownership_invalid_binding\n%c${parent} passed property \`${prop}\` to ${child} with \`bind:\`, but its parent component ${owner} did not declare \`${prop}\` as a binding. Consider creating a binding between ${owner} and ${parent} (e.g. \`bind:${prop}={...}\` instead of \`${prop}={...}\`)\nhttps:/*                                                     */
	} else {
		console.warn(`https:/*                                       */
	}
}

/**
 *
 *
 *
 *
 *
 */
export function ownership_invalid_mutation(name, location, prop, parent) {
	if (DEV) {
		console.warn(`%c[svelte] ownership_invalid_mutation\n%cMutating unbound props (\`${name}\`, at ${location}) is strongly discouraged. Consider using \`bind:${prop}={...}\` in ${parent} (or using a callback) instead\nhttps:/*                                                      */
	} else {
		console.warn(`https:/*                                        */
	}
}

/**
 *
 */
export function select_multiple_invalid_value() {
	if (DEV) {
		console.warn(`%c[svelte] select_multiple_invalid_value\n%cThe \`value\` property of a \`<select multiple>\` element should be an array, but it received a non-array value. The selection will be kept as is.\nhttps:/*                                                         */
	} else {
		console.warn(`https:/*                                           */
	}
}

/**
 *
 *
 */
export function state_proxy_equality_mismatch(operator) {
	if (DEV) {
		console.warn(`%c[svelte] state_proxy_equality_mismatch\n%cReactive \`$state(...)\` proxies and the values they proxy have different identities. Because of this, comparisons with \`${operator}\` will produce unexpected results\nhttps:/*                                                         */
	} else {
		console.warn(`https:/*                                           */
	}
}

/**
 *
 */
export function state_proxy_unmount() {
	if (DEV) {
		console.warn(`%c[svelte] state_proxy_unmount\n%cTried to unmount a state proxy, rather than a component\nhttps:/*                                               */
	} else {
		console.warn(`https:/*                                 */
	}
}

/**
 *
 */
export function svelte_boundary_reset_noop() {
	if (DEV) {
		console.warn(`%c[svelte] svelte_boundary_reset_noop\n%cA \`<svelte:boundary>\` \`reset\` function only resets the boundary the first time it is called\nhttps:/*                                                      */
	} else {
		console.warn(`https:/*                                        */
	}
}

/**
 *
 *
 */
export function transition_slide_display(value) {
	if (DEV) {
		console.warn(`%c[svelte] transition_slide_display\n%cThe \`slide\` transition does not work correctly for elements with \`display: ${value}\`\nhttps:/*                                                    */
	} else {
		console.warn(`https:/*                                      */
	}
}